import {Button, Modal} from 'react-bootstrap';
import createReactClass from 'create-react-class';

import TrainModal from './TrainModal.js';
import myAjax from '../global/libs/myAjax.js';
import CONFIG from '../global/libs/CONFIG.js';
import QACandidatePanelBottomMailModal from './QACandidatePanelBottomMailModal.js';
import './Common.css';
import PropTypes from 'prop-types';

let AnswerPanelTableIsCorrectTr = createReactClass({
  // ARGS: question, result, gotoQACandidatePanel, askQuestion, generateAlert
  propTypes: {
    question: PropTypes.string.isRequired,
    result: PropTypes.object.isRequired,
    gotoQACandidatePanel: PropTypes.func.isRequired,
    askQuestion: PropTypes.func.isRequired,
    generateAlert: PropTypes.func.isRequired,
    logId: PropTypes.number.isRequired,
    cgId: PropTypes.string.isRequired
  },

  getInitialState() {
    return {
      correctModal: false,
      correctConfirmModal: false
    };
  },

  closeCorrectConfirmModal() {
    this.setState({correctConfirmModal: false});
  },

  openCorrectModal() {
    this.setState({correctModal: true});
  },

  closeCorrectModal() {
    this.setState({correctModal: false});
  },

  handleCorrectClick() {
    this.setState({correctConfirmModal: true});
  },

  handleCorrectClickConfirm() {
    this.setState({correctConfirmModal: false});
    myAjax('/api/qa_data/qa_paraphrase/', {
      qa_id: this.props.result.id,
      paraphrase: this.props.question
    }).done(
      function () {
        this.openCorrectModal();
      }.bind(this)
    );
  },

  render() {
    let gotoQACandidatePanel = this.props.gotoQACandidatePanel;
    let askQuestion = this.props.askQuestion;
    let question = this.props.question;
    let result = this.props.result;
    let generateAlert = this.props.generateAlert;
    let thisReturn = <span />;

    const buttonVariant = 'secondary';

    if (!('paraphrases' in result)) {
      result.paraphrases = [];
    }
    if (result.question !== question && result.paraphrases.indexOf(question) === -1) {
      thisReturn = (
        <tr>
          <td colSpan="3" style={{borderTop: '0px'}}>
            <div style={{marginBottom: '12px', textAlign: 'center'}}>
              <h4>聞きたい質問はこちらの質問でしょうか？</h4>
              <p>
                {CONFIG.ENABLE_QA_PARAPHRASE ? ( // #6205 2018.02.20 modify
                  <Button variant={buttonVariant} onClick={this.handleCorrectClick}>
                    はい、言い回しを登録
                  </Button>
                ) : null}
                {CONFIG.ENABLE_QA_PARAPHRASE ? <span>&#160;or&#160;</span> : null}
                {CONFIG.ENABLE_INQUIRY && CONFIG.DISPLAY_INQUIRY_BUTTON_ALWAYS ? (
                  <QACandidatePanelBottomMailModal
                    question={this.props.question}
                    result={result}
                    result_id={this.props.result.id}
                    logId={this.props.logId}
                    cgId={this.props.cgId}
                  />
                ) : null}
                {CONFIG.ENABLE_INQUIRY && CONFIG.DISPLAY_INQUIRY_BUTTON_ALWAYS ? ( // #6205 2018.02.20 modify
                  <span>&#160;or&#160;</span>
                ) : null}
                <Button variant={buttonVariant} onClick={gotoQACandidatePanel}>
                  &#160;&#160;他の関連質問を見る&#160;&#160;
                </Button>
              </p>
            </div>

            {/* correctModal */}
            <TrainModal
              showModal={this.state.correctModal}
              closeModal={this.closeCorrectModal}
              gotoNextPanel={askQuestion.bind(null, question)}
              generateAlert={generateAlert.bind(null, '質問の言い回しを学習しました！')}
            >
              学習中。。。しばらくお待ち下さい
            </TrainModal>

            <Modal show={this.state.correctConfirmModal} onHide={this.closeCorrectConfirmModal}>
              <Modal.Body>
                <br />
                <Modal.Title>
                  <p>{'"' + question + '"'}</p>
                </Modal.Title>
                をこの質問の言い回しとして登録します。．
                <br />
                よろしいですか？
              </Modal.Body>
              <Modal.Footer>
                <Button variant="primary" onClick={this.handleCorrectClickConfirm}>
                  &#160;&#160;&#160;&#160;&#160;OK&#160;&#160;&#160;&#160;&#160;
                </Button>
                &#160;
                <Button onClick={this.closeCorrectConfirmModal}>キャンセル</Button>
              </Modal.Footer>
            </Modal>
          </td>
        </tr>
      );
    } else {
      thisReturn = (
        <tr>
          <td colSpan="3" style={{borderTop: '0px', paddingBottom: '7px'}}>
            <center>
              {CONFIG.ENABLE_INQUIRY && CONFIG.DISPLAY_INQUIRY_BUTTON_ALWAYS ? (
                <div style={{marginBottom: '12px'}}>
                  <QACandidatePanelBottomMailModal
                    question={this.props.question}
                    result={result}
                    result_id={this.props.result.id}
                    logId={this.props.logId}
                    cgId={this.props.cgId}
                  />
                </div>
              ) : null}
            </center>
          </td>
        </tr>
      );
    }
    return thisReturn;
  }
});

export default AnswerPanelTableIsCorrectTr;
